/* 100 positive affirmations for The Pronoia — rotate one after another
   with a soft breathing glow. Client-side only, zero cloud cost. */
export const PRONOIA_AFFIRMATIONS = [
  'The Universe works for me.',
  'People work for me — known, unknown, seen, unseen.',
  'Friends and colleagues work for me.',
  'Strangers on my path work for me.',
  'Everything works for me.',
  'Every moment works for me.',
  'Every situation works for me.',
  'Every setback works for me.',
  'Every delay works for me.',
  'Every closed door works for me.',

  'Every open door works for me.',
  'Every yes works for me.',
  'Every no works for me — it clears a better path.',
  'Every coincidence is a signal.',
  'Every green light is a nod from Providence.',
  'Every red light is protecting me.',
  'Every helpful text arrives right on time.',
  'Every wrong turn leads me somewhere better.',
  'The living, the non-living — all works for me.',
  'The hidden and the open — all works for me.',

  'The seen and the unseen conspire in my favour.',
  'Time works for me.',
  'Space works for me.',
  'Weather works for me.',
  'Traffic works for me.',
  'Silence works for me.',
  'Noise works for me.',
  'Rest works for me.',
  'Work works for me.',
  'Sleep works for me.',

  'I am close to getting what I want.',
  'It is already coming.',
  'It is already on its way.',
  'It is being prepared right now.',
  'It is closer than yesterday.',
  'It is arriving in perfect timing.',
  'What is meant for me will not miss me.',
  'What is mine finds me easily.',
  'What I need meets me halfway.',
  'What I ask for is already handled.',

  'Money flows toward me from expected and unexpected sources.',
  'Opportunities line up in my favour.',
  'Doors open before I knock.',
  'Right people appear at the right time.',
  'Right ideas arrive when I am ready.',
  'The right words come to me effortlessly.',
  'My timing is divine timing.',
  'My path is being cleared as I walk it.',
  'My steps are guided.',
  'My mind is protected.',

  'My body is supported.',
  'My heart is aligned.',
  'My work bears fruit.',
  'My name is spoken well in rooms I am not in.',
  'My kindness returns to me multiplied.',
  'My patience is being rewarded.',
  'My focus is a magnet for miracles.',
  'My peace attracts abundance.',
  'My silence attracts wisdom.',
  'My rest attracts renewal.',

  'The Universe is rearranging things for my highest good.',
  'The Universe never runs out of ways to bless me.',
  'The Universe has already said yes.',
  'The Universe is not late, and neither am I.',
  'The Universe delivers exactly what I hold in my mind.',
  'Every cell in my body is being upgraded.',
  'Every breath brings me closer.',
  'Every sunrise resets my chances.',
  'Every night I am being made ready for morning.',
  'Every prayer has been received.',

  'I am a favourite of Providence.',
  'I am watched, guided, and protected.',
  'I am always in the right room, at the right hour.',
  'I am always given exactly what I need.',
  'I am becoming who I am meant to be.',
  'I am softer where I need to be soft.',
  'I am stronger where I need to be strong.',
  'I am welcome wherever I go.',
  'I am respected even in my absence.',
  'I am unshakable.',

  'Money likes me.',
  'Time likes me.',
  'People like me before they meet me.',
  'Luck likes me.',
  'Life likes me.',
  'The best is arranging itself around me.',
  'Nothing is against me — even what feels hard.',
  'Nothing is late — even what feels slow.',
  'Nothing is lost — even what feels missed.',
  'Nothing is wasted — every step counts.',

  'The plan for me is bigger than the plan I made.',
  'The answer is already forming.',
  'The wait is a preparation, not a punishment.',
  'The delay is protection, not rejection.',
  'The version of me that already has it is calling me forward.',
  'I receive with open hands.',
  'I trust the unfolding.',
  'I keep going — providence keeps arriving.',
  'It is coming. It is close. It is here.',
  'The Universe works for me — now, and always.',
];
